




import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import ThemeSelector from './cardbuilder/ThemeSelector.js';
import CardForm from './cardbuilder/CardForm.js';
import { defaultCardData } from '../Components/types/cardData.js';
import CardPreview from './cardbuilder/CardPreview.js';
import FinalCardView from './cardbuilder/FinalCardView.js';
import axios from 'axios';
import { cardThemes } from './utils/cardThemes.js';



const CardBuilder = () => {
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [cardData, setCardData] = useState(defaultCardData);

  const [activeTab, setActiveTab] = useState('form');
  const [viewMode, setViewMode] = useState('builder');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleDataChange = (field, value) => {
    setCardData(prev => ({ ...prev, [field]: value }));
  };

  const [userEmail, setUserEmail] = useState(null);
  const [websiteUrl, setWebsiteUrl] = useState(null);

  console.log("userEmail", userEmail)
  console.log("websiteUrl", websiteUrl)

  useEffect(() => {
    const email = sessionStorage.getItem("email");
    const url = sessionStorage.getItem("websiteUrl");
    console.log("url", url)
    if (!email) return;
    const fetchExistingCard = async () => {
      try {
        const response = await axios.get('https://api.nfcdesignstudio.com/API/v1/api/getform');
        const allCards = response.data;
        const existingCard = allCards.find(card => card.email?.trim() === email?.trim());
        console.log(existingCard);
        if (existingCard) {
          setCardData(existingCard);
          const fullTheme = cardThemes.find(t => t.id === existingCard.themeId) || cardThemes[0];
          setSelectedTheme(fullTheme);
          setViewMode("final");
          setIsEditMode(false);
          setUserEmail(existingCard.email);
          setWebsiteUrl(existingCard.websiteUrl);
        }
      } catch (err) {
        console.error("Error fetching existing card:", err);
      }
    };
    fetchExistingCard();
  }, []);



  const handleSubmit = async () => {
    if (!selectedTheme) {
      alert('Please select a theme first');
      return;
    }
    if (!cardData.name || !cardData.companyName || !cardData.designation) {
      alert('Please fill Name, Company Name, and Designation');
      return;
    }
    if (!cardData.call && !cardData.email) {
      alert('Please provide at least Phone or Email');
      return;
    }
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append('themeId', selectedTheme.id);
      Object.entries(cardData).forEach(([key, value]) => {
        if (!value) return;
        if (key === 'themeId') return;   // ✅ prevent duplicate
        formData.append(key, value);
      });

      const apiUrl = userEmail
        ? 'https://api.nfcdesignstudio.com/API/v1/api/updateCardData'
        : 'https://api.nfcdesignstudio.com/API/v1/submit-form';

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,

      });
      const result = await response.json();
      console.log('Server response:', result);
      if (result.data) {
        setCardData(result.data);
        const updatedTheme = cardThemes.find(t => t.id === result.data.themeId) || cardThemes[0];
        setSelectedTheme(updatedTheme);
      }
      if (result.data?.email) sessionStorage.setItem('email', result.data.email);
      if (result.data?.websiteUrl) sessionStorage.setItem('websiteUrl', result.data.websiteUrl);
      setViewMode('final');
      setIsEditMode(false);
      setUserEmail(result.data?.email);
      alert('Card saved successfully!');
    } catch (err) {
      console.error('Error submitting card:', err);
      alert('Something went wrong, please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleSaveFromFinal = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        alert('Card saved successfully!');
        resolve(true);
      }, 1000);
    });
  };

  const handleBackToEdit = () => {
    setIsEditMode(true);
    setViewMode('builder');
  };

  // ----------------- FINAL VIEW -----------------
  if (viewMode === 'final') {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} style={{ position: 'fixed', inset: 0, background: '#fff', zIndex: 50, overflowY: 'auto', }}>
        <FinalCardView
          data={cardData}
          theme={selectedTheme}
          onBack={handleBackToEdit}
          onSave={handleSaveFromFinal}
          userEmail={cardData.email}
          userMobile={cardData.call}
        />
      </motion.div>
    );
  }

  // ----------------- BUILDER VIEW -----------------
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} style={{ position: 'fixed', inset: 0, backdropFilter: 'blur(4px)', zIndex: 50, overflow: 'hidden', display: 'flex', flexDirection: 'column', }}>
      {/* Header */}
      <div style={{ flexShrink: 0, borderBottom: '1px solid #ccc', background: 'rgba(255,255,255,0.5)', backdropFilter: 'blur(10px)', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <div>
          <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>Digital Card Builder</h2>
          <p style={{ fontSize: 14, color: '#555', margin: 0 }}>Create your professional NFC business card</p>
        </div>

        {/* Links */}
        <div style={{ display: 'flex', gap: '16px' }}>
          {/* <a href="/vfc-card" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }} > VFC Card</a> */}
          <a href="/profile" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }}> Profile</a>
        </div>
      </div>


      {/* Main Content */}
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        {/* Left Column: Form */}
        {(activeTab === 'form' || window.innerWidth >= 1024) && (
          <div style={{ flex: 1, overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ padding: 16, borderRadius: 24, background: '#fff', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}><ThemeSelector selectedTheme={selectedTheme} onSelectTheme={setSelectedTheme} /></div>
            <div style={{ padding: 16, borderRadius: 24, background: '#fff', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}><CardForm data={cardData} onChange={handleDataChange} /></div>
            <div style={{ padding: 16, borderRadius: 24, background: '#fff', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', marginTop: 'auto' }}>
              <button onClick={handleSubmit} disabled={isSubmitting} style={{ width: '100%', padding: 16, borderRadius: 16, border: 'none', background: 'linear-gradient(to right, #6366f1, #22d3ee)', color: '#fff', fontWeight: 'bold', fontSize: 16, cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, }}>
                {isSubmitting ? (
                  <>
                    <Loader2 size={24} style={{ animation: 'spin 1s linear infinite' }} />
                    {isEditMode ? 'Updating Card...' : 'Creating Card...'}
                  </>
                ) : (
                  isEditMode ? 'Update My Card' : 'Create My Card'
                )}
              </button>
            </div>
          </div>
        )}

        {/* Right Column: Preview */}
        {(activeTab === 'preview' || window.innerWidth >= 1024) && (
          <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
            <div style={{ padding: 16, borderRadius: 24, background: selectedTheme?.colors?.background || '#fff', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', }}>
              <CardPreview data={cardData} theme={selectedTheme} />
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default CardBuilder;
